(function () {
  'use strict';

  var ROOT_SELECTOR = '[data-ns-collection-description]';
  var TOGGLE_SELECTOR = '[data-ns-description-toggle]';
  var CLOSE_SELECTOR = '[data-ns-description-close]';
  var PANEL_SELECTOR = '[data-ns-description-panel]';

  function finishAfterTransition(panel, callback) {
    var finished = false;

    function finish() {
      if (finished) return;

      finished = true;
      panel.removeEventListener('transitionend', finish);
      callback();
    }

    panel.addEventListener('transitionend', finish);
    window.setTimeout(finish, 450);
  }

  function getElements(root) {
    return {
      toggle: root.querySelector(TOGGLE_SELECTOR),
      panel: root.querySelector(PANEL_SELECTOR),
      label: root.querySelector('[data-ns-toggle-label]')
    };
  }

  function openDescription(root) {
    var elements = getElements(root);

    if (!elements.toggle || !elements.panel) return;

    elements.panel.hidden = false;
    elements.panel.setAttribute('aria-hidden', 'false');
    elements.toggle.setAttribute('aria-expanded', 'true');

    if (elements.label) {
      elements.label.textContent = root.dataset.readLess;
    }

    elements.panel.style.height = '0px';

    window.requestAnimationFrame(function () {
      elements.panel.style.height =
        elements.panel.scrollHeight + 'px';
    });

    finishAfterTransition(elements.panel, function () {
      if (
        elements.toggle.getAttribute('aria-expanded') === 'true'
      ) {
        elements.panel.style.height = 'auto';
      }
    });
  }

  function closeDescription(root, returnFocus) {
    var elements = getElements(root);

    if (!elements.toggle || !elements.panel) return;

    elements.panel.style.height =
      elements.panel.scrollHeight + 'px';

    elements.panel.setAttribute('aria-hidden', 'true');
    elements.toggle.setAttribute('aria-expanded', 'false');

    if (elements.label) {
      elements.label.textContent = root.dataset.readMore;
    }

    window.requestAnimationFrame(function () {
      elements.panel.style.height = '0px';
    });

    finishAfterTransition(elements.panel, function () {
      if (
        elements.toggle.getAttribute('aria-expanded') === 'false'
      ) {
        elements.panel.hidden = true;
        elements.panel.style.height = '';
      }
    });

    if (returnFocus) {
      elements.toggle.focus();
    }
  }

  function toggleDescription(root) {
    var toggle = root.querySelector(TOGGLE_SELECTOR);

    if (!toggle) return;

    if (toggle.getAttribute('aria-expanded') === 'true') {
      closeDescription(root, false);
    } else {
      openDescription(root);
    }
  }

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest(TOGGLE_SELECTOR);
    var close = event.target.closest(CLOSE_SELECTOR);
    var control = toggle || close;

    if (!control) return;

    var root = control.closest(ROOT_SELECTOR);

    if (!root) return;

    if (toggle) {
      toggleDescription(root);
    } else {
      closeDescription(root, true);
    }
  });

  document.addEventListener(
    'shopify:section:unload',
    function (event) {
      event.target
        .querySelectorAll(PANEL_SELECTOR)
        .forEach(function (panel) {
          panel.style.height = '';
        });
    }
  );
})();